import Component from "@glimmer/component"
import styles from "./toggle-button.module.css"

export default class UserOnboardingToggleButtonComponent extends Component {
  readonly styles = styles
}
